module.exports = __webpack_public_path__ + "img/payment-error.f7642a9.svg";